import { createSlice } from '@reduxjs/toolkit';
import { getLegacyTiposTrabajoOt } from '../legacy/thunk.js';

export const initialState = {
    legacyTiposTrabajoOt: [],
    loading: false,
    error: {},
};

const legacyTiposTrabajoOtSlice = createSlice({
    name: 'legacyTiposTrabajoOt',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getLegacyTiposTrabajoOt.fulfilled, (state, action) => {
            state.legacyTiposTrabajoOt = action.payload;
            state.loading = true;
        });
        builder.addCase(getLegacyTiposTrabajoOt.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.loading = true;
        });
        builder.addCase(getLegacyTiposTrabajoOt.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
    }
});

export default legacyTiposTrabajoOtSlice.reducer;